import { RoomMessgaeType } from "@/share/Room";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { MediaEvent } from "@/media/MediaEvent";
import { MediaObject } from "./MediaObject";
import SimplePeer from 'simple-peer';
import { timeout } from "@/background/store/MediaStore";
import hark from 'hark';
/**
 *
 * Server Side: 1) Atomically create room
 *              2) Device based streaming id = userid_deviceid_time()
 *              3) messages relay
 *              4) delete room cleanup
 *              5) Add active call tag for all vertual letr
 *
 * Cliend Side: 1) Start my local stream
 *              2) Enabled for video and audio stream
 *              3) Detect active speaker
 *              4) reconnect
 *              5) disconnect from call
 *              6) Join active call
 *              7) Active call tag for filtering active ongoing letrs call
 */
class PeerCore {
    constructor() {
        this.sharescreenactive = false;
        this.mylocalid = Math.random() + "";
        this.simplepeerconnection = new Map();
        this.muted = false;
        this.enablevideo = false;
        this.mediaobject = new Map();
        MediaEvent.addSubcriberForNewMember((newmemebr) => {
            const mobj = new MediaObject(newmemebr.member, false);
            mobj.setAddingPeer(true);
            mobj.setUserName(newmemebr.fullname);
            MediaEvent.publishMediaObject(mobj);
            this.connectPeer(newmemebr.member);
        });
        MediaEvent.addSubcriberForNewOffer((offer) => this.peerMessage(offer));
    }
    startMyCall(incoming) {
        const req = {
            incoming: incoming
        };
        this.sendMessageToBackground(req, 'addtoroom');
    }
    async sharescreen() {
        try {
            if (this.sharescreenactive) {
                return undefined;
            }
            try {
                const stream = await navigator.mediaDevices.getDisplayMedia();
                if (stream) {
                    this.myscreensharestream = stream;
                }
            }
            catch (ex) {
            }
            this.sharescreenactive = true;
            if (this.myscreensharestream !== undefined &&
                this.mysharingstream !== undefined && this.mysharingstream.getVideoTracks().length > 0) {
                const prvtrack = this.mysharingstream.getVideoTracks()[0];
                // now lets display replace all peers older stuff here
                for (const [peer, peerobj] of this.simplepeerconnection) {
                    if (peerobj.connected) {
                        peerobj.replaceTrack(prvtrack, this.myscreensharestream.getVideoTracks()[0], this.mysharingstream);
                        peerobj.send("sharingscreen");
                    }
                }
            }
            else if (this.myscreensharestream !== undefined &&
                this.mysharingstream !== undefined && this.mysharingstream.getVideoTracks().length == 0) {
                this.mysharingstream.addTrack(this.myscreensharestream.getVideoTracks()[0]);
                for (const [peer, peerobj] of this.simplepeerconnection) {
                    if (peerobj.connected) {
                        peerobj.addTrack(this.myscreensharestream.getVideoTracks()[0], this.mysharingstream);
                        peerobj.send("sharingscreen");
                    }
                }
            }
            if (this.myscreensharestream !== undefined) {
                this.myscreensharestream.getVideoTracks()[0].onended = () => {
                    MediaEvent.publishSharingStopped();
                };
            }
            return this.myscreensharestream;
        }
        catch (ex) { }
        return undefined;
    }
    async stopScreenShare() {
        if (!this.sharescreenactive) {
            return undefined;
        }
        this.sharescreenactive = false;
        if (this.mylocalstream !== undefined && this.mysharingstream !== undefined
            && this.mylocalstream.getVideoTracks().length > 0) {
            const prvtrack = this.mysharingstream.getVideoTracks()[0];
            // now lets display replace all peers older stuff here
            for (const [peer, peerobj] of this.simplepeerconnection) {
                if (peerobj.connected) {
                    peerobj.replaceTrack(prvtrack, this.mylocalstream.getVideoTracks()[0], this.mysharingstream);
                    peerobj.send("stoppedsharingscreen");
                }
            }
        }
        else if (this.mylocalstream !== undefined && this.mysharingstream !== undefined
            && this.mylocalstream.getVideoTracks().length === 0) {
            const prvtrack = this.mysharingstream.getVideoTracks()[0];
            this.mysharingstream.removeTrack(prvtrack);
            // now lets display replace all peers older stuff here
            for (const [peer, peerobj] of this.simplepeerconnection) {
                if (peerobj.connected) {
                    peerobj.removeTrack(prvtrack, this.mysharingstream);
                    peerobj.send("stoppedsharingscreen");
                }
            }
        }
        return this.mylocalstream;
    }
    connectPeer(peerid) {
        const peer = new SimplePeer({
            initiator: true,
            trickle: true,
            config: {
                iceServers: [{ "urls": "stun:mediastun.letrwing.com:3478?transport=udp" },
                    { "username": "lwmedia",
                        "urls": "turn:mediaturn.letrwing.com:3478?transport=udp",
                        "credential": "NDF94gJy3jkJNVbf" }, { "username": "lwmedia",
                        "urls": "turn:mediaturn.letrwing.com:3478?transport=tcp",
                        "credential": "NDF94gJy3jkJNVbf" },
                    { "username": "lwmedia",
                        "urls": "turn:mediaturn.letrwing.com:443?transport=udp",
                        "credential": "NDF94gJy3jkJNVbf" }]
            },
        });
        this.simplepeerconnection.set(peerid, peer);
        if (this.sharescreenactive && this.mysharingstream !== undefined
            && this.myscreensharestream !== undefined) {
            const vt = this.mysharingstream.getVideoTracks();
            for (const v of vt) {
                this.mysharingstream.removeTrack(v);
            }
            this.myscreensharestream.getVideoTracks().forEach((tr) => { var _a; return (_a = this.mysharingstream) === null || _a === void 0 ? void 0 : _a.addTrack(tr); });
        }
        if (this.mysharingstream !== undefined) {
            peer.addStream(this.mysharingstream);
        }
        peer.on("connect", () => {
            if (this.muted) {
                peer.send("audiomute");
            }
            else {
                peer.send("audiounmute");
            }
            if (this.sharescreenactive) {
                peer.send("sharingscreen");
            }
            else {
                peer.send("stoppedsharingscreen");
            }
            if (this.enablevideo) {
                peer.send("videoenable");
            }
            else {
                peer.send("videodisable");
            }
        });
        peer.on("close", () => {
            this.simplepeerconnection.delete(peerid);
            MediaEvent.publishPeerDisconnected(peerid);
        });
        peer.on('signal', data => {
            const offermessage = {
                message: {
                    peerid: peerid, fullname: "",
                    message: LetrwingCrypto.getBase64FromUT8(JSON.stringify(data))
                },
                messgaetype: RoomMessgaeType.Offer,
            };
            this.sendMessageToBackground(offermessage, "mediamessage");
        });
        peer.on('error', err => {
            if (err.message !== "ERR_WEBRTC_SUPPORT") {
                this.sendMessageToBackground(peerid, "checkpeerconnected");
            }
        });
        peer.on("data", (data) => {
            data = LetrwingCrypto.getUTF8FromBin(data);
            console.log("data " + data);
            if (data === 'audiounmute') {
                MediaEvent.publishAudioMuteUnmute({ peerid: peerid, mute: false });
            }
            else if (data === 'audiomute') {
                MediaEvent.publishAudioMuteUnmute({ peerid: peerid, mute: true });
            }
            else if (data === "sharingscreen") {
                MediaEvent.publishSharingScreen({ peerid: peerid, sharing: true });
            }
            else if (data === "stoppedsharingscreen") {
                MediaEvent.publishSharingScreen({ peerid: peerid, sharing: false });
            }
            else if (data === "speaking") {
                MediaEvent.publishSpeaking(peerid);
            }
            else if (data === 'videofacingcamera') {
                MediaEvent.publishVideoFacingCamera(peerid);
            }
            else if (data === 'videoenvcamera') {
                MediaEvent.publishVideoEnvCamera(peerid);
            }
            else if (data === "disconnected") {
                this.simplepeerconnection.delete(peerid);
                if (!this.checkIfAnyConnectedPeers()) {
                    this.disConnect();
                }
            }
        });
        peer.on('stream', stream => {
            const npeobj = new MediaObject(peerid, false);
            npeobj.setHasVideo(true);
            npeobj.setAddingPeer(false);
            npeobj.setMediaStream(stream);
            MediaEvent.publishMediaObject(npeobj);
        });
    }
    peerMessage(offer) {
        var _a;
        const peerdata = LetrwingCrypto.fromBase64ToUTF8(offer.message);
        const sdata = JSON.parse(peerdata);
        if (!this.simplepeerconnection.has(offer.peerid)) {
            const peer = new SimplePeer({
                initiator: false,
                trickle: true,
                config: {
                    iceServers: [{ "urls": "stun:mediastun.letrwing.com:3478?transport=udp" },
                        { "username": "lwmedia",
                            "urls": "turn:mediaturn.letrwing.com:3478?transport=udp",
                            "credential": "NDF94gJy3jkJNVbf" }, { "username": "lwmedia",
                            "urls": "turn:mediaturn.letrwing.com:3478?transport=tcp",
                            "credential": "NDF94gJy3jkJNVbf" },
                        { "username": "lwmedia",
                            "urls": "turn:mediaturn.letrwing.com:443?transport=udp",
                            "credential": "NDF94gJy3jkJNVbf" }]
                },
            });
            this.simplepeerconnection.set(offer.peerid, peer);
            const peermediaobj = new MediaObject(offer.peerid, false);
            peermediaobj.setAddingPeer(true);
            peermediaobj.setUserName(offer.fullname);
            MediaEvent.publishMediaObject(peermediaobj);
            if (this.sharescreenactive && this.mysharingstream !== undefined
                && this.myscreensharestream !== undefined) {
                const vt = this.mysharingstream.getVideoTracks();
                for (const v of vt) {
                    this.mysharingstream.removeTrack(v);
                }
                this.myscreensharestream.getVideoTracks().forEach((tr) => { var _a; return (_a = this.mysharingstream) === null || _a === void 0 ? void 0 : _a.addTrack(tr); });
            }
            if (this.mysharingstream !== undefined) {
                peer.addStream(this.mysharingstream);
            }
            peer.signal(sdata);
            peer.on("connect", () => {
                if (this.muted) {
                    peer.send("audiomute");
                }
                else {
                    peer.send("audiounmute");
                }
                if (this.sharescreenactive) {
                    peer.send("sharingscreen");
                }
                else {
                    peer.send("stoppedsharingscreen");
                }
                if (this.enablevideo) {
                    peer.send("videoenable");
                }
                else {
                    peer.send("videodisable");
                }
            });
            peer.on("data", (data) => {
                data = LetrwingCrypto.getUTF8FromBin(data);
                console.log("data " + data);
                if (data === 'audiounmute') {
                    MediaEvent.publishAudioMuteUnmute({ peerid: offer.peerid, mute: false });
                }
                else if (data === 'audiomute') {
                    MediaEvent.publishAudioMuteUnmute({ peerid: offer.peerid, mute: true });
                }
                else if (data === "sharingscreen") {
                    MediaEvent.publishSharingScreen({ peerid: offer.peerid, sharing: true });
                }
                else if (data === "stoppedsharingscreen") {
                    MediaEvent.publishSharingScreen({ peerid: offer.peerid, sharing: false });
                }
                else if (data === "speaking") {
                    MediaEvent.publishSpeaking(offer.peerid);
                }
                else if (data === 'videofacingcamera') {
                    MediaEvent.publishVideoFacingCamera(offer.peerid);
                }
                else if (data === 'videoenvcamera') {
                    MediaEvent.publishVideoEnvCamera(offer.peerid);
                }
                else if (data === "disconnected") {
                    this.simplepeerconnection.delete(offer.peerid);
                    if (!this.checkIfAnyConnectedPeers()) {
                        this.disConnect();
                    }
                }
            });
            peer.on("close", () => {
                this.simplepeerconnection.delete(offer.peerid);
                MediaEvent.publishPeerDisconnected(offer.peerid);
            });
            peer.on('error', err => console.log('error', err));
            peer.on('stream', stream => {
                const npeobj = new MediaObject(offer.peerid, false);
                npeobj.setUserName(offer.fullname);
                npeobj.setHasVideo(true);
                npeobj.setAddingPeer(false);
                npeobj.setMediaStream(stream);
                MediaEvent.publishMediaObject(npeobj);
            });
            peer.on("signal", (data) => {
                const offermessage = {
                    message: {
                        peerid: offer.peerid,
                        message: LetrwingCrypto.getBase64FromUT8(JSON.stringify(data)),
                        fullname: ""
                    },
                    messgaetype: RoomMessgaeType.Offer
                };
                this.sendMessageToBackground(offermessage, "mediamessage");
            });
        }
        else {
            (_a = this.simplepeerconnection.get(offer.peerid)) === null || _a === void 0 ? void 0 : _a.signal(sdata);
        }
    }
    addMediaObject(mobj) {
        this.mediaobject.set(mobj.id, mobj);
    }
    async createStream(audioinput, videoinput) {
        const audio = {
            deviceId: audioinput,
        };
        let videocon = undefined;
        if (videoinput !== undefined && videoinput) {
            videocon = {
                deviceId: videoinput,
            };
        }
        else {
            videoinput = undefined;
        }
        try {
            this.mylocalstream = await navigator.mediaDevices.getUserMedia({
                audio: audio,
                video: videocon !== undefined ? videocon : false
            });
            const lmysharingstream = new MediaStream();
            this.mylocalstream.getTracks().forEach(tr => lmysharingstream.addTrack(tr));
            this.mysharingstream = lmysharingstream;
            const speech = hark(this.mylocalstream);
            speech.on('speaking', () => {
                // tell everyone I m speaking
                this.publishIMSpeaking();
            });
            return this.mylocalstream;
        }
        catch (ex) {
        }
        return undefined;
    }
    async getMediaDevices() {
        let index = 0;
        while (index < 2) {
            try {
                const str = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: index < 1 ? true : false
                });
                str.getTracks().forEach(tr => tr.stop());
                await timeout(100);
                let devices = await navigator.mediaDevices.enumerateDevices();
                if (index >= 1) {
                    const dv = devices.filter((dv) => dv.kind === "audioinput");
                    devices = dv;
                }
                return devices;
            }
            catch (ex) {
                console.log(ex);
            }
            index++;
        }
        return undefined;
    }
    async switchMediaDevices(toggleCamera) {
        let stream = undefined;
        const mode = toggleCamera ? "environment" : "user";
        try {
            stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: { facingMode: {
                        exact: mode
                    } }
            });
        }
        catch (ex) {
            alert(ex);
            return undefined;
        }
        return stream;
    }
    async shareSwitchedMedia(audioinput, videoinput) {
        const audio = {
            deviceId: audioinput,
        };
        let videocon = undefined;
        if (videoinput !== undefined && videocon) {
            videocon = {
                deviceId: videoinput,
            };
        }
        try {
            this.mylocalstream = await navigator.mediaDevices.getUserMedia({
                audio: audio,
                video: videocon !== undefined ? videocon : false
            });
            if (this.mylocalstream !== undefined &&
                this.mysharingstream !== undefined && this.mysharingstream.getVideoTracks().length > 0) {
                const currtrack = this.mysharingstream.getVideoTracks()[0];
                for (const [peer, peerobj] of this.simplepeerconnection) {
                    if (peerobj.connected) {
                        peerobj.replaceTrack(currtrack, this.mylocalstream.getVideoTracks()[0], this.mysharingstream);
                    }
                }
            }
            else if (this.mylocalstream !== undefined &&
                this.mysharingstream !== undefined && this.mysharingstream.getVideoTracks().length == 0) {
                this.mysharingstream.addTrack(this.mylocalstream.getVideoTracks()[0]);
                for (const [peer, peerobj] of this.simplepeerconnection) {
                    if (peerobj.connected) {
                        peerobj.addTrack(this.mylocalstream.getVideoTracks()[0], this.mysharingstream);
                    }
                }
            }
            if (this.mylocalstream !== undefined &&
                this.mysharingstream !== undefined && this.mysharingstream.getAudioTracks().length > 0) {
                const currtrack = this.mysharingstream.getAudioTracks()[0];
                for (const [peer, peerobj] of this.simplepeerconnection) {
                    if (peerobj.connected) {
                        peerobj.replaceTrack(currtrack, this.mylocalstream.getAudioTracks()[0], this.mysharingstream);
                    }
                }
            }
            else if (this.mylocalstream !== undefined &&
                this.mysharingstream !== undefined && this.mysharingstream.getAudioTracks().length == 0) {
                this.mysharingstream.addTrack(this.mylocalstream.getAudioTracks()[0]);
                for (const [peer, peerobj] of this.simplepeerconnection) {
                    if (peerobj.connected) {
                        peerobj.addTrack(this.mylocalstream.getAudioTracks()[0], this.mysharingstream);
                    }
                }
            }
            return this.mylocalstream;
        }
        catch (ex) {
            console.log(ex);
            return undefined;
        }
    }
    getMyLocalStream() {
        return this.mylocalstream;
    }
    async createMyStream() {
        try {
            this.mylocalstream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: { facingMode: 'user' }
            });
            const lmysharingstream = new MediaStream();
            this.mylocalstream.getTracks().forEach(tr => lmysharingstream.addTrack(tr));
            this.mysharingstream = lmysharingstream;
            const speech = hark(this.mylocalstream);
            speech.on('speaking', () => {
                // tell everyone I m speaking
                this.publishIMSpeaking();
            });
            return this.mylocalstream;
        }
        catch (ex) {
            return undefined;
        }
    }
    publishIMSpeaking() {
        for (const [peer, peerobj] of this.simplepeerconnection) {
            if (peerobj.connected) {
                peerobj.send("speaking");
            }
        }
    }
    async publishDisconnected() {
        for (const [peer, peerobj] of this.simplepeerconnection) {
            if (peerobj.connected) {
                peerobj.send("disconnected");
                await timeout(100);
                peerobj.destroy();
            }
        }
    }
    muteMyAudio() {
        if (this.mysharingstream !== undefined) {
            this.mysharingstream.getAudioTracks()[0].enabled = false;
            this.muted = true;
            this.announceMute();
        }
    }
    async disConnect() {
        var _a, _b, _c;
        this.publishDisconnected();
        this.simplepeerconnection = new Map();
        (_a = this.mylocalstream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach((tr) => tr.stop());
        (_b = this.myscreensharestream) === null || _b === void 0 ? void 0 : _b.getTracks().forEach((tr) => tr.stop());
        (_c = this.mysharingstream) === null || _c === void 0 ? void 0 : _c.getTracks().forEach((tr) => tr.stop());
        MediaEvent.publishShutdown();
    }
    muteMyVideo() {
        if (this.mysharingstream !== undefined && !this.sharescreenactive) {
            this.mysharingstream.getVideoTracks()[0].enabled = false;
            this.enablevideo = false;
            this.announceNoVideo();
        }
    }
    unmuteMyAudio() {
        if (this.mysharingstream !== undefined) {
            this.mysharingstream.getAudioTracks()[0].enabled = true;
            if (this.mysharingstream.getVideoTracks().length === 0
                && !this.sharescreenactive) {
                for (const [peer, peerobj] of this.simplepeerconnection) {
                    if (peerobj.connected) {
                        peerobj.replaceTrack(this.mysharingstream.getAudioTracks()[0], this.mysharingstream.getAudioTracks()[0], this.mysharingstream);
                    }
                }
            }
            this.muted = false;
            this.announceUnMute();
        }
    }
    unmuteMyVideo() {
        if (this.mysharingstream !== undefined && !this.sharescreenactive) {
            this.mysharingstream.getVideoTracks()[0].enabled = true;
            this.enablevideo = true;
            this.announceVideo();
        }
    }
    checkIfAnyConnectedPeers() {
        if (this.simplepeerconnection !== undefined) {
            for (const [p, v] of this.simplepeerconnection) {
                if (v.connected) {
                    console.log("peer connected true");
                    return true;
                }
            }
        }
        console.log("peer connected false");
        return false;
    }
    async announceMute() {
        await timeout(1);
        for (const [peer, peerobj] of this.simplepeerconnection) {
            if (peerobj.connected) {
                peerobj.send("audiomute");
            }
        }
    }
    async announceUnMute() {
        await timeout(1);
        for (const [peer, peerobj] of this.simplepeerconnection) {
            if (peerobj.connected) {
                peerobj.send("audiounmute");
            }
        }
    }
    async announceVideo() {
        for (const [peer, peerobj] of this.simplepeerconnection) {
            if (peerobj.connected) {
                peerobj.send("videoenable");
            }
        }
    }
    async announceNoVideo() {
        for (const [peer, peerobj] of this.simplepeerconnection) {
            if (peerobj.connected) {
                peerobj.send("videodisable");
            }
        }
    }
    sendMessageToBackground(message, ename) {
        const bmessage = {
            name: ename,
            message: message
        };
        MediaEvent.publishForSendMessage(JSON.stringify(bmessage));
    }
}
export const MediaPeerCore = new PeerCore();
